import { Box, Drawer, Typography, IconButton, Divider, Stack } from '@mui/material';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import { useNavigate, useParams } from 'react-router-dom';
import QaChunkFormSkeleton from '../../../Agent/Configure/QaChunk/Components/QaChunkFormSkeleton';
import { useCreateOrUpdateChunk, useGetChunk } from '@/apis/business/setting/knowledgeBase/hook';
import { RxCross2 } from 'react-icons/rx';
import { useEffect } from 'react';

export default function QuestionAnswerForm() {
  const navigate = useNavigate();
  const { chunkId } = useParams();

  const { mutateAsync: saveChunk, isPending } = useCreateOrUpdateChunk();
  const { data: chunk, isLoading } = useGetChunk();

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      question: '',
      answer: ''
    }
  });

  useEffect(() => {
    if (chunk) {
      reset({
        question: chunk.question ?? '',
        answer: chunk.answer ?? ''
      });
    }
  }, [chunk, reset]);

  const onSubmit = async (data: any) => {
    await saveChunk(data);
  };

  if (isLoading) return <QaChunkFormSkeleton />;

  return (
    <Drawer
      anchor='right'
      open
      onClose={() => navigate(-1)}
      slotProps={{
        paper: {
          sx: {
            width: 640,
            display: 'flex',
            flexDirection: 'column'
          }
        }
      }}
    >
      <Box px={3} py={2} display='flex' alignItems='center' justifyContent='space-between'>
        <Typography fontSize={20} fontWeight={600}>
          {chunkId ? 'Edit Question & Answer' : 'Question & Answer'}
        </Typography>

        <IconButton onClick={() => navigate(-1)}>
          <RxCross2 />
        </IconButton>
      </Box>

      <Divider />
      <Box
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            px: 3,
            py: 3
          }}
        >
          <Stack spacing={3}>
            <Input name='question' label='Question' control={control} fullWidth required />

            <Input name='answer' label='Answer' control={control} minRows={8} multiline fullWidth required />
          </Stack>
        </Box>

        <Divider />

        {/* FOOTER */}
        <Box px={3} py={2}>
          <Stack direction='row' justifyContent='flex-end' spacing={2}>
            <Button variant='outlined' onClick={() => navigate(-1)}>
              Cancel
            </Button>

            <Button type='submit' isPending={isPending}>
              {chunkId ? 'Update' : 'Create'}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Drawer>
  );
}
